import { render, staticRenderFns } from "./PermissionRoomsRepeater.vue?vue&type=template&id=4ca1853c&scoped=true"
import script from "./PermissionRoomsRepeater.vue?vue&type=script&lang=js"
export * from "./PermissionRoomsRepeater.vue?vue&type=script&lang=js"
import style0 from "./PermissionRoomsRepeater.vue?vue&type=style&index=0&id=4ca1853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca1853c",
  null
  
)

export default component.exports